import { CalendarMonthOutlined, HeadphonesRounded } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    Grid,
    Stack,
    Typography,
} from '@mui/material';
import { capitalCase } from 'change-case';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ShowMoreText from 'react-show-more-text';

export default function CrusadeItem({ theme, crusade }) {
    const navigate = useNavigate();

    const {
        id,
        dates,
        church,
        description,
        media,
        owner,
        pastor,
        title,
        tag,
        status,
        interactions,
    } = crusade;

    return (
        <Grid item xs={12}>
            <Card variant="outlined">
                <CardContent
                    sx={{ bgcolor: theme }}
                    onClick={() =>
                        navigate(`/crusade/${id}`, { replace: true })
                    }
                >
                    <Stack
                        sx={{ mb: 2 }}
                        direction="row"
                        className="text-white"
                        justifyContent="space-between"
                    >
                        {renderStatus(status, dates)}
                        <Typography className="fw-bold">#{tag}</Typography>
                    </Stack>
                    <Stack
                        direction="row"
                        className="text-white"
                        justifyContent="space-between"
                    >
                        <Box>
                            <Typography variant="h5">{title}</Typography>
                            {status == 'live' && (
                                <Box
                                    sx={{ my: 0.5 }}
                                    className="d-flex text-white align-items-center"
                                >
                                    <HeadphonesRounded sx={{ mr: 1 }} />
                                    <Typography
                                        variant="body2"
                                        className="d-flex fw-bold  align-items-center"
                                        sx={{ mt: 1 }}
                                    >
                                        {interactions?.listening} tuned in
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Box
                            sx={{
                                ml: 1,
                                width: 80,
                                height: 50,
                                borderRadius: 0.5,
                                backgroundImage: `url(${media?.link})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}
                        />
                    </Stack>
                </CardContent>
                <CardContent className="text-white" sx={{ bgcolor: '#545454' }}>
                    <Stack sx={{ mb: 1 }} direction="row" alignItems="center">
                        <Avatar
                            src={church?.avatar || pastor?.avatar}
                            sx={{ mr: 1 }}
                        >
                            {church?.id
                                ? church?.name?.slice(0, 2)
                                : pastor?.name?.slice(0, 2)}
                        </Avatar>
                        <div>
                            <Typography component="div" className="fw-bold">
                                {church?.id ? church?.name : pastor?.name}{' '}
                                <Chip
                                    className="text-white"
                                    size="small"
                                    label="host"
                                />
                            </Typography>
                            <Typography
                                sx={{ lineHeight: 0.8 }}
                                variant="body2"
                            >
                                {capitalCase(owner || '')}
                            </Typography>
                        </div>
                    </Stack>
                    <ShowMoreText lines={2} more="more" less="less">
                        {description}
                    </ShowMoreText>
                </CardContent>
            </Card>
        </Grid>
    );
}

const renderStatus = (status, dates) => (
    <>
        {status == 'live' ? (
            <Stack direction="row" alignItems="center">
                <Box
                    className="bg-danger"
                    sx={{
                        borderRadius: '50%',
                        width: 10,
                        height: 10,
                        mr: 1,
                    }}
                />
                <Typography className="text-white text-success fw-bold">
                    Live
                </Typography>
            </Stack>
        ) : (
            <Stack direction="row" alignItems="center">
                <CalendarMonthOutlined sx={{ mr: 1, width: 36, height: 36 }} />
                <Stack>
                    <Typography className="fw-bold" variant="body2">
                        {moment(dates?.start).format('ll')}
                    </Typography>
                    <Typography className="fw-bold" variant="body2">
                        {moment(dates?.start).format('LT')}
                    </Typography>
                </Stack>
            </Stack>
        )}
    </>
);
